import React, { useState } from 'react';
import classes from './RoleSelector.module.scss';

import arrowSVG from '../../assets/svgs/Arrow.svg';

const roles = ['Admin', 'Viewer', 'Commentor', 'Owner'];

const RoleSelector = () => {
  const [currentRole, setCurrentRole] = useState(0);

  const handlePrevious = () => {
    setCurrentRole((prev) => (prev === 0 ? roles.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentRole((prev) => (prev === roles.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className={classes.selector}>
      <button className={classes.arrow} onClick={handlePrevious}>
        <img src={arrowSVG} alt="" className={classes['arrow-routed']} />
      </button>
      <span className={classes.text}>{roles[currentRole]}</span>
      <button className={classes.arrow} onClick={handleNext}>
        <img src={arrowSVG} alt="" />
      </button>
    </div>
  );
};

export default RoleSelector;
